import { AtlasV2ConversionPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2ConversionPageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasV2ConversionLayout({ metricType }) {
  const conversionPageLayout = {
    purchaseRate: AtlasV2ConversionPageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'conversionPageLayout',
        CustomComponent: conversionPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
